import StrategicResultsPanel from './StrategicResultsPanel';

export default StrategicResultsPanel;
